import { addGenevaLog, getQueryParamDictionary, getSynchronousLocale } from './statelessUtil';

/**
 * Checks if app is agavePane
 * @returns boolean
 */
export const isAgavePane = (): boolean => {
  const queryParams = getQueryParamDictionary(window.location.href);
  return queryParams.isagave === 'true';
};

/**
 * Fucntion to handle Office.OnReady call before initializing emerald app
 * @param callback function to be called to load bundle and resources
 * @returns void
 */
export const loadEmerald = (callback: (locale: string) => void) => {
  let locale = 'en-us';
  if (isAgavePane()) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Office.onReady((_info: any) => {
      if (Office.context && Office.context.displayLanguage) {
        locale = Office.context.displayLanguage;
      }
      callback(locale);
      // eslint-disable-next-line promise/prefer-await-to-then
    }).catch(error => {
      const errorMessage = error ? error.message : '';
      const errorStack = error ? error.stack : '';
      const logHandlerTags = {
        content: {
          contentId: 'loadEmeraldBootStrapOffice',
          contentName: 'loadEmeraldBootStrapOffice',
          formnm: 'maxFunnel',
          areaName: 'ErrorBoundary',
          url: `${window.location.href}`,
          errorMessage,
          errorStack,
        },
        behavior: 'OTHER',
      };
      addGenevaLog(logHandlerTags);
      callback(locale);
    });
  } else {
    locale = getSynchronousLocale();
    callback(locale);
  }
  return;
};
